import React from 'react';
import styled from 'styled-components';
import { SkeletonLine, SkeletonExpansible } from '../../Skeleton';
import { Placeholder, Content, Inner, AspectRatioContent } from '../partials';
export var StyledSkeleton = styled.div.withConfig({
  displayName: "VideoCardSkeleton__StyledSkeleton",
  componentId: "sc-1i5uxpc-0"
})(["display:flex;flex-flow:column;height:230px;"]);
export var VideoCardSkeleton = function VideoCardSkeleton() {
  return React.createElement(Inner, null, React.createElement(Placeholder, null, React.createElement(AspectRatioContent, null, React.createElement(SkeletonExpansible, null))), React.createElement(Content, null, React.createElement(SkeletonLine, {
    style: {
      height: '18px',
      width: '100%'
    }
  }), React.createElement(SkeletonLine, {
    style: {
      height: '18px',
      width: '100%',
      marginTop: '6px'
    }
  })));
};